import type { AccordionProps as MuiAccordionProps } from '@mui/material';
import { Accordion as MuiAccordion } from '@mui/material';

export type AccordionProps = MuiAccordionProps;

/** Shows accordion around the children component. Based on MUI Accordion: https://mui.com/material-ui/react-accordion/ */
export const Accordion = (props: AccordionProps) => <MuiAccordion {...props} />;
